// Templates

export type Nullable<T> = T | null;

export type Maybe<T> = T | undefined;

export type AnyArgsVoidFunc = (...args: any[]) => void;

export type NoArgsVoidFunc = () => void;

// General

export const noopFunc = () => void 0;

// Web misc

export const perf = window.performance;

// DOM

export function getDOMElement<T extends HTMLElement>(id: string): T | null {
  const el = document.getElementById(id);
  if (!el) {
    console.warn('DOM element not found by id: ' + id);
    return null;
  }
  return el as T;
}

// Typecheck

export function isUndefined(val: any): val is undefined {
  return typeof val === 'undefined';
}

export function isNumber(val: any): val is number {
  return typeof val === 'number';
}

export function isString(val: any): val is string {
  return typeof val === 'string';
}

export function isObject<T extends object>(val: T): val is T {
  return typeof val === 'object';
}

// Result/Flow

export function orNull<T>(val?: T): T | null {
  return val || null;
}

export function orZero<T>(val?: T): T | 0 {
  return val || 0;
}

// Memory

export function arrayUnstrictShift<T>(a: Array<T>): T {
  return <T> a.shift();
}

export function arrayUnstrictPop<T>(a: Array<T>): T {
  return <T> a.pop();
}

export function getDataViewOfTypedArray(bufferView: ArrayBufferView): DataView {
  const {buffer, byteOffset, byteLength} = bufferView;
  return new DataView(buffer, byteOffset, byteLength);
}
